export const getCoordinateString = (x, y) => {
    let colName = '';
    let dividend = x + 1;
    while (dividend > 0) {
        const modulo = (dividend - 1) % 26;
        colName = String.fromCharCode('A'.charCodeAt(0) + modulo) + colName;
        dividend = Math.floor((dividend - 1 - modulo) / 26);
    }
    const rowNumber = y + 1;
    return `${colName}${rowNumber}`;
};
/** Inverse of getCoordinateString: "B10" -> { x: 1, y: 9 }. null if malformed. */
export const parseCoordinateString = (coord) => {
    const m = /^([A-Z]+)(\d+)$/.exec(coord);
    if (!m)
        return null;
    let x = 0;
    for (const ch of m[1])
        x = x * 26 + (ch.charCodeAt(0) - 64);
    return { x: x - 1, y: parseInt(m[2], 10) - 1 };
};
